import type { Form } from '@/api';
import type { FormOverview } from '@/hooks/useFormOverview';
import type { InstantSave } from '@/hooks/useInstantSave';
import type { SiteMethod } from '@/lib/form-site';
import type { FormSpec } from '@/lib/form-specs';

/** What every section of the overview reads. */
export interface SectionProps {
  /** The form with pending instant saves applied. */
  form: Form;
  save: InstantSave['save'];
  /** Refusals per field from the last save, shown under that field. */
  errors: InstantSave['errors'];
  setErrors: InstantSave['setErrors'];
  data: FormOverview;
  /** The parsed fields, null when there are none or the TOML does not parse. */
  spec: FormSpec | null;
  method: SiteMethod;
  /** At least one message has arrived. */
  hasMessages: boolean;
}

export function asMethod(value: string | undefined | null): SiteMethod {
  return value === 'hosted' || value === 'link' ? value : 'own';
}
